import { SideRibType } from "./util-types";

export const SIDE_RIB_TYPE_TITLES: Record<SideRibType, string> = {
  [SideRibType.NONE]: "Нет",
  [SideRibType.UP]: "Диагональ вверх",
  [SideRibType.DOWN]: "Диагональ вниз",
  [SideRibType.BOTH]: "Крест-накрест",
};
